import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Fourchettes de budget — qualification douce qui remplace l'ancienne étape
// « gamme » (Essentiel/Confort/Signature) : chaque projet est conçu sur-mesure,
// la fourchette sert seulement à calibrer la proposition.
// `floor` = borne basse factuelle stockée en base (budget_estime) ; le libellé
// exact est transmis dans les notes de la demande.
const BUDGET_RANGES: { key: string; label: string; floor?: number }[] = [
  { key: 'moins-5k', label: 'Moins de 5 000 €' },
  { key: '5k-10k', label: '5 000 € – 10 000 €', floor: 5000 },
  { key: '10k-20k', label: '10 000 € – 20 000 €', floor: 10000 },
  { key: 'plus-20k', label: 'Plus de 20 000 €', floor: 20000 },
  { key: 'a-definir', label: 'Je préfère en discuter' },
];

interface ParticulierDetailsStepProps {
  onComplete: (data: {
    nombreInvites: number;
    budgetIndicatif?: number;
    budgetFourchette?: string;
  }) => void;
}

export const ParticulierDetailsStep = ({ onComplete }: ParticulierDetailsStepProps) => {
  const [nombreInvites, setNombreInvites] = useState<number>(0);
  const [budgetKey, setBudgetKey] = useState<string>('');

  const handleSubmit = () => {
    const data: { nombreInvites: number; budgetIndicatif?: number; budgetFourchette?: string } = { nombreInvites };
    const range = BUDGET_RANGES.find(r => r.key === budgetKey);
    if (range) {
      data.budgetFourchette = range.label;
      if (range.floor) data.budgetIndicatif = range.floor;
    }
    onComplete(data);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="nombreInvites">Nombre d'invités *</Label>
        <Input
          id="nombreInvites"
          type="number"
          value={nombreInvites || ''}
          onChange={(e) => setNombreInvites(parseInt(e.target.value) || 0)}
          placeholder="Combien d'invités ?"
          min="1"
          required
        />
        <p className="text-sm text-muted-foreground">
          Cela nous permet d'ajuster les quantités des prestations « par personne ».
        </p>
      </div>

      <div className="space-y-2">
        <Label>Budget envisagé (optionnel)</Label>
        <Select value={budgetKey} onValueChange={setBudgetKey}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Sélectionnez une fourchette" />
          </SelectTrigger>
          <SelectContent position="popper" side="bottom" align="start" className="z-[9999] bg-background border border-border shadow-lg min-w-full">
            {BUDGET_RANGES.map((r) => (
              <SelectItem key={r.key} value={r.key}>{r.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-sm text-muted-foreground">
          Une simple indication pour calibrer notre proposition — chaque projet est conçu sur-mesure.
        </p>
      </div>

      <Button
        onClick={handleSubmit}
        disabled={nombreInvites <= 0}
        className="w-full"
      >
        Continuer
      </Button>
    </div>
  );
};
